import { Button, Result, Typography } from 'antd';
import moment from 'moment';
import React from 'react';
import Auction from '../../../core/models/Auction';

interface IProps {
  auction: Auction;
  loading: boolean;
  onStart: () => void;
}

const StartAuction: React.FC<IProps> = ({ auction, loading, onStart }) => {
  return (
    <Result
      status='info'
      title='Auction has not started yet'
      extra={
        <>
          <Typography.Text style={{ fontWeight: '600' }}>Auction Date/Time:</Typography.Text>
          <Typography.Text style={{ fontWeight: '400' }}>
            {moment(auction?.auctionDate).format('DD/MM/YYYY HH:mm')}
          </Typography.Text>
          <br />
          <Typography.Text>
            {moment.duration(moment(auction?.auctionDate).diff(moment()).toString()).humanize()} to
            go
          </Typography.Text>
          <br />
          <br />
          <Button type='primary' onClick={onStart} loading={loading}>
            Start Auction
          </Button>
        </>
      }
    />
  );
};

export default StartAuction;
